/* Mobile Footer-Accordion */

document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.grid .footer-block__heading');

  const handleCollapse = (heading) => {
    const content = heading.nextElementSibling;

    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed');
      heading.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';
    } else {
      heading.classList.add('block-collapsed');
      heading.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
    }
  };

  headings.forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    const content = heading.nextElementSibling;
    if (content) {
      content.setAttribute('id', `footer-block-index-${index}`);
      heading.setAttribute('aria-controls', `footer-block-index-${index}`);
    }

    heading.addEventListener('click', () => handleCollapse(heading));

    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleCollapse(heading);
      }
    });
  });
});


/* Description code */

document.addEventListener("DOMContentLoaded", function () {
  const text = document.getElementById("descText");
  const btn = document.getElementById("toggleBtn");

  if (!text || !btn) return;
  
  // check agar content 5 lines se zyada hai
  if (text.scrollHeight > text.clientHeight) {
    btn.style.display = "inline-block";
  }

  btn.addEventListener("click", function () {
    if (text.classList.contains("expanded")) {
      text.classList.remove("expanded");
      btn.innerText = "See more";
    } else {
      text.classList.add("expanded");
      btn.innerText = "See less";
    }
  });
});

// Removes the newsletter success state from the URL to prevent the message from showing again after page refresh.

  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.search.includes("customer_posted=true")) {
      // Remove URL parameter after showing message once
      const url = new URL(window.location);
      url.searchParams.delete("customer_posted");
      window.history.replaceState({}, document.title, url.pathname);
    }
  });